import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button, Label, Container, Modal,Spinner, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import Select from "react-select";
import 'toastr/build/toastr.min.css'
import Dropzone from "react-dropzone";
import axios from "axios";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
 import { BaseUrl } from "../../helpers/Baseurl";
 import { Link } from "react-router-dom"
 import default_img from "../../assets/images/default.jpg"
 import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'

 const RoleGroup =  [
  { 
      label: "Role",
      options: [
        { label: "Manage Itinerary", value: 0 },
        { label: "Manage Payments", value: 1 },
        { label: "Manage Agents", value: 3 },
        { label: "Manage All", value: 2 },
      ]
  }
];


class UpdateUser extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 10, 'edit' )){
      this.props.history.push('/users')
    }
    this.state = {
      breadcrumbItems: [
        { title: "Users", link: "/users" },
        { title: "User Detail", link: "#" },
      ],
      loading: false,
      modal_center: false,
      selectedCountry: { label: "Select Country", value: null },
      selectedState:{ label: "Select State", value: null },
      selectedCity:{ label: "Select City", value: null },
      selectedPermissionGroup:{ label: "Select Permission Group", value: null },
      UserPermissionGroup:[],
      StateGroup:[],
      CountriesGroup:[],
      CityGroup:[],
      user : [],
      selectedFiles: false,
    };
    
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000

  }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.tog_center = this.tog_center.bind(this);
    this.handleSelectCountry = this.handleSelectCountry.bind(this);
    this.handleSelectState = this.handleSelectState.bind(this);
    this.handleSelectCity = this.handleSelectCity.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handleSelectedPermissionGroup = this.handleSelectedPermissionGroup.bind(this);
    // this.changeHandeler.bind(this);

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")  
    this.props.history.push('/dashboard')
  }
  componentDidMount(){
    this.LoadUserData()
    this.loadCountryData()
    this.loadAllGroups()
    
  }
  async loadAllGroups(){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'},
    };
    await fetch(`${BaseUrl}/api/accounts/group/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map((role) => {
                    options.push({ label: role.name, value: role })
                  })
              
                  let UserPermissionGroup = [
                    { 
                        label: "Permission Groups",
                        options: options
                    }
                ];
                this.setState({ UserPermissionGroup:UserPermissionGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
    }

  async LoadUserData(){
    const id =this.props.match.params.id
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
      };
    
    await fetch(`${BaseUrl}/api/accounts/users/${id}/`,requestOptions)
          .then(res => res.json())
          .then(
              (data) => {
                console.log(data)
                let selectedCountry = this.state.selectedCountry
                let selectedState = this.state.selectedState
                let selectedCity = this.state.selectedCity
                let selectedRole = { label: "Manage Itinerary", value: 0 }
                let selectedPermissionGroup = { label: "Select Permission Group", value: null }
                if (data.role === 1){
                  selectedRole = { label: "Manage Payments", value: 1 }
                }
                if (data.role === 2){
                  selectedRole = { label: "Manage All", value: 2 }
                }
                if (data.country){
                  selectedCountry= { label: data.country.name, value: data.country.id }
                }
                if (data.state){
                  selectedState= { label: data.state.name, value: data.state.id }
                }
                if (data.city){
                  selectedCity= { label: data.city.name, value: data.city.id }
                }
                if (data.group){
                  selectedPermissionGroup = { label: data.group.name, value: data.group }
                }

                this.setState({ user: data,
                                selectedCountry:selectedCountry, 
                                selectedState:selectedState,
                                selectedCity:selectedCity,
                                selectedRole,
                                selectedPermissionGroup,
                    })
              },
              (error) => {
                  console.log(error, 'error-------------')
                
              }
          ) 

  }
  async loadCountryData(){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/countries/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(country => {
                    options.push({ label: country.name, value: country.id })
                  })
               
                  let CountriesGroup = [
                    { 
                        label: "Country",
                        options: options
                    }
                ];
                this.setState({ CountriesGroup:CountriesGroup  })      
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }
   async loadStateData(country){
  
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/states/${country}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(state => {
                    options.push({ label: state.name, value: state.id })
                  })
               
                  let StateGroup = [
                    { 
                        label: "State",
                        options: options
                    }
                ];
                this.setState({ StateGroup:StateGroup  })      
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

   async loadCityData(state){
  
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/cities/${state}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(city => {
                    options.push({ label: city.name, value: city.id })
                  })
               
                  let CityGroup = [
                    { 
                        label: "City",
                        options: options
                    }
                ];
                this.setState({ CityGroup:CityGroup  })      
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

  handleSelectCountry = selectedCountry => {
    this.loadStateData(selectedCountry.value)
    this.setState({ selectedCountry  })
  };

  handleSelectState = selectedState => {
    this.loadCityData(selectedState.value)
    this.setState({ selectedState  })
  };
  handleSelectCity = selectedCity => {
    this.setState({ selectedCity });
  };

  handleSelectedRole = selectedRole => {
    this.setState({ selectedRole })

  }

  handleSelectedPermissionGroup = selectedPermissionGroup => {
    this.setState({ selectedPermissionGroup })
  }
 
  
   handleAcceptedFiles = files => {
    let file = files[0]
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      }) 
    this.setState({ selectedFiles: file });
  };
  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  
  tog_center() {
    this.setState(prevState => ({
      modal_center: !prevState.modal_center
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  
  handleSubmit(e,  values) {
    
    const { user } = this.state
    if (this.state.selectedCity.value && this.state.selectedCity.value !== ""){
      this.setState({ loading: true })
    
      const formData = new FormData();

      if(this.state.selectedFiles){
        formData.append("image", this.state.selectedFiles);
      }
      if(this.state.selectedPermissionGroup.value){
        formData.append("group", this.state.selectedPermissionGroup.value.id);
      }
      formData.append("email", values.email)
      formData.append("first_name", values.first_name)
      formData.append("last_name", values.last_name)
      formData.append("phone",values.phone)
      formData.append("country", this.state.selectedCountry.value)
      formData.append("state",this.state.selectedState.value) 
      formData.append("city",this.state.selectedCity.value) 
      formData.append("zip_code", values.zip_code)
      formData.append("is_superuser", user.is_superuser) 
      formData.append("role", this.state.selectedRole.value) 
      if(values.password !== "" && values.password!==undefined && values.password === values.password1){
        formData.append("password",values.password)
      }else{
        formData.append("password",user.password)
      }

      axios.put(
        `${BaseUrl}/api/accounts/users/${user.id}/`,
        formData,
        {
            headers: {
                "Content-type": "multipart/form-data",
            },                    
        }
      )
      .then(res => {
          console.log(res, "---------------")

          let data =  res.data; 
          toastr.success(`User Updated SuccessFully`, "") 
          this.setState({ loading: false, user:data, modal_center: false  })
      })
      .catch(err => {
          console.log(err, "----------------------error");
          this.setState({ loading: false})
      })   
    }else{
      toastr.warning(`Select City`, "")  
    }
  }

  
  render() {
    const {CountriesGroup, selectedCountry, selectedState, StateGroup, selectedCity, CityGroup, selectedRole, user } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Profile" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col lg={6}>
                <Card>
                  <CardBody>
                  <Row>
                      <Col md={6}>
                          <div className="m-4">
                            {user.image?
                              <img className="rounded avatar-xl" alt="image" src={user.image} />
                              :
                              <img className="rounded avatar-xl" alt="image" src={default_img} />
                            }
                          </div>
                          </Col>

                         
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">First Name</Label><br></br>
                            <b>{user?user.first_name:""}</b>
                           
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="last_name">Last Name</Label><br></br>
                           
                              <b>{user.last_name}</b>
                            
                          </div>
                        </Col>
                      </Row>
                      <hr className="my-4" />
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">Email</Label><br></br>
                            <b>{user.email}</b>
                           
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="last_name">Phone Number</Label><br></br>
                           
                              <b>{user.phone}</b>
                            
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">Country</Label><br></br>
                            <b>{user.country?user.country.name:""}</b>
                           
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">State</Label><br></br>
                            <b>{user.state?user.state.name:""}</b>
                           
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">City</Label><br></br>
                            <b>{user.city?user.city.name:""}</b>
                           
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">Zip Code</Label><br></br>
                            <b>{user.zip_code?user.zip_code:""}</b>
                           
                          </div>
                        </Col>
                      </Row>
                      <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">Role</Label><br></br>
                            <b>{user.role === 0? "Manage Itinerary": 
                            (user.role === 1? "Manage Payments": (user.role === 2? "Manage All":"")
                            )
                          }</b>
                           
                          </div>
                        </Col>
                      <Row>
                      <Col sm={6} md={4} xl={3} className="mt-4">
                        {/* <Link  to="#" onClick={this.tog_center} className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link> */}
                        <Button
                            type="button"
                            color="primary" className="waves-effect waves-light"
                            onClick={this.tog_center}
                          >
                            Edit User
                        </Button>

                        <Modal
                          isOpen={this.state.modal_center}
                          toggle={this.tog_center}
                          centered={true}
                        >
                          <ModalHeader toggle={() => this.setState({ modal_center: false })}>
                          Update {user.first_name?user.first_name+" "+user.last_name: user.email } Detail
                          </ModalHeader>
                          <ModalBody>
                          <AvForm onValidSubmit={this.handleSubmit}>
                     
                     <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="first_name">First Name</Label>
                            <AvField
                              name="first_name"
                              placeholder="First Name"
                              type="text"
                              errorMessage="Enter First Name"
                              className="form-control"
                              id="first_name"
                              value={user.first_name}
                            />
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="last_name">Last Name</Label>
                            <AvField
                              name="last_name"
                              placeholder="Last Name"
                              type="text"
                              errorMessage="Enter Last Name"
                              className="form-control"
                              id="last_name"
                              value={user.last_name}
                            />
                          </div>
                        </Col>
                      </Row>
        
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <AvField
                              name="email"
                              label="E-Mail"
                              placeholder="Enter Valid Email"
                              type="email"
                              errorMessage="Invalid Email"
                              value={user.email}
                              // disabled
                              id="email"
                            />
                          </div>
                        </Col>
                         <Col md="6">
                          <div className="mb-3">
                            <AvField
                              name="phone"
                              label="Contact No."
                              placeholder="Enter Only number"
                              type="number"
                              errorMessage="Enter Only Number"
                              value={user.phone}
                              validate={{
                                pattern: {
                                  value: "^[0-9]+$",
                                  errorMessage: "Only Numbers"
                                },
                                maxLength: {
                                  value: 15,
                                  errorMessage: "Numbers must be less than 16 digit"},
                                minLength: {
                                  value: 10,
                                  errorMessage: "Numbers must be Grater than 9 digit"}   
                              }}
                            />
                          </div>
                        </Col>
                       </Row>
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Country</Label>
                              <Select 
                              value={selectedCountry}
                              onChange={this.handleSelectCountry}
                              options={CountriesGroup}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                        </Col>
                        <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">State</Label>
                                <Select 
                                value={selectedState}
                                onChange={this.handleSelectState}
                                options={StateGroup}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                        </Col>
                      </Row>
                       <Row>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">City</Label>
                                    <Select 
                                    value={selectedCity}
                                    onChange={this.handleSelectCity}
                                    options={CityGroup}
                                    classNamePrefix="select2-selection"
                                    />

                                </div>
                            </Col>
                            <Col md="6">
                            <div className="mb-3">
                              <AvField
                                name="zip_code"
                                label="Pin Code"
                                placeholder="Enter Only number"
                                type="number"
                                value={user.zip_code}
                               errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                  
                                  maxLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be less than 7 digit"},
                                  minLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be Grater than 5 digit"}   
                                }}
                              />
                            </div>
                          </Col> 

                        </Row> 
                            <Row>
                            <Col md="6">  
                              <div className="mb-3">
                                <Label>Change Password</Label>
                                <AvField
                                  name="password"
                                  type="password"
                                  placeholder="Password"
                                  errorMessage="Enter password"
                                  autoComplete="new-password"
                                />
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                <Label>Confirm Password</Label>
                                <AvField
                                  name="password1"
                                  type="password"
                                  placeholder="Re-type Password"
                                  errorMessage="Enter Re-password"
                                  validate={{
                                    match: { value: "password" }
                                  }}
                                />
                                </div>
                              </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Role</Label>
                                  <Select 
                                  value={selectedRole}
                                  onChange={this.handleSelectedRole}
                                  options={RoleGroup}
                                  classNamePrefix="select2-selection"
                                  />

                              </div>
                            </Col>
                            <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Permission Group</Label>
                                  <Select 
                                  value={this.state.selectedPermissionGroup}
                                  onChange={this.handleSelectedPermissionGroup}
                                  options={this.state.UserPermissionGroup}
                                  classNamePrefix="select2-selection"
                                  />

                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                            <Dropzone
                                    accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                                    maxSize={1000000}
                                    onDrop = {(acceptedFiles) => {

                                      this.handleAcceptedFiles(acceptedFiles)
                                      }}
                                    
                                    
                                >
                                    {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                        <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                        >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                            <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                        </div>
                                        <h6>Drop only .jpeg/.jpg/.png Images here or click to upload.</h6>
                                        <h6>Images size is less than 1 MB.</h6>
                                        </div>
                                    </div>
                                    )}
                                </Dropzone>
                                <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                >
                                    {this.state.selectedFiles?
                                        <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={"-file"}
                                        >
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                            <Col className="col-auto">
                                                <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={this.state.selectedFiles.name}
                                                src={this.state.selectedFiles.preview}
                                                />
                                            </Col>
                                            <Col>
                                                <Link
                                                to="#"
                                                className="text-muted fw-bold"
                                                >
                                                {this.state.selectedFiles.name}
                                                </Link>
                                                <p className="mb-0">
                                                <strong>{this.state.selectedFiles.formattedSize}</strong>
                                                </p>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Card>:""}
                                    
                                    
                                </div>
                            </Col>
                        </Row>   

                        <FormGroup className="mb-0">
                        {this.state.loading?(
                          <Spinner className="me-2 mt-2" color="primary" />
                        ):(
                          <div>
                      
                        <Button type="submit" color="primary" className="me-1">
                          Submit
                        </Button>
                        </div>
                          )}
                      </FormGroup>  
                  </AvForm>
                          </ModalBody>
                        </Modal>
                      </Col>
                      </Row>
                    
                
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default UpdateUser;
